module.exports = __webpack_public_path__ + "static/media/25.b83274e5.png";